import {Component} from "@angular/core";

@Component({
    selector: "fui-statements",
    styleUrls: ["./statements.component.scss"],
    templateUrl: "./statements.component.html"
})
export class FUIStatementsComponent {
    constructor() {

    }
}
